import { API_ROUTE_FIND_MATCH_ON_DEMAND } from '../ContextManager/constants';
import { AnalyticsEvents, logEvent } from './analyticsService';

/** How long to wait for the request to reach the backend before letting go. */
const REQUEST_TIMEOUT_MS = 10000;

/**
 * Triggers the backend's on-demand MatchUp flow (`findMatchOnDemand`) for a
 * single who just finished filling their data, asking it to find their best
 * match and dispatch a new proposal (the dispatch pipeline notifies the
 * matchers of both sides).
 *
 * Fire-and-forget by design: the cloud function aggregates the entire
 * candidates pool and can run for minutes, so callers must not block the UI
 * on it. The request is aborted client-side after a short timeout - the
 * function keeps matching server-side. Errors are logged and swallowed; the
 * periodic batch algorithm remains the fallback for generating proposals.
 *
 * @param {string|null|undefined} singleId The `singles` collection doc id.
 */
export function triggerFindMatch(singleId) {
  if (!singleId) {
    console.log('onDemandMatchService: no single id, skipping trigger.');
    return;
  }

  logEvent(AnalyticsEvents.onDemandMatchTriggered, { single_id: singleId });

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const url =
    `${apiBaseUrl}${API_ROUTE_FIND_MATCH_ON_DEMAND}` +
    `?singleId=${encodeURIComponent(singleId)}&dispatch=true`;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  fetch(url, { mode: 'cors', signal: controller.signal })
    .catch((e) => {
      // Includes the expected AbortError when the matching run outlives the
      // client-side timeout.
      console.log(`onDemandMatchService: trigger for ${singleId} ended:`, e);
    })
    .finally(() => clearTimeout(timeout));
}
